import { HttpBackend, HttpErrorResponse, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { catchError, map, Observable, of, throwError } from 'rxjs';

import { LogEntry } from "@core/classes";
import { LogPublisher, WebAPILogData } from '@shared/models/log.interface';


export class WebAPILog<T> implements LogPublisher {
  location = '';

  constructor(endpoint: string, private httpBackend: HttpBackend) {
    this.location = endpoint;
  }

  log(logEntry: LogEntry, usingMobileDevice: boolean, token: string, jtiProvided: string = ''): Observable<boolean> {
    let payload: WebAPILogData = {
      ...logEntry.basicLogDetails,
      ...logEntry.deviceLogDetails,
      ...logEntry.extendedLogDetails,
      user_id: logEntry.extendedLogDetails?.user_id || 'anonymous',
    };

    let logRequestHeader: HttpHeaders;
    // if (usingMobileDevice && jtiProvided) {
      logRequestHeader = new HttpHeaders({ 'Authorization': `Bearer ${token}`, 'X-Er-Type': jtiProvided });
    /*
    }
    else {
      logRequestHeader = new HttpHeaders({ 'Authorization': `Bearer ${token}` });
    }
    */
    return this.httpBackend.handle(new HttpRequest("POST", this.location, payload, { headers: logRequestHeader })).pipe(
      map(response => {
        if (response instanceof HttpResponse && response.status === 200)
          return true;
        return false;
      }),
      catchError(this.handleErrors)
    )
  }

  clear(logEntry: LogEntry): Observable<boolean> {
    return of(false);
  }

  private handleErrors(error: any): Observable<any> {
   /*  let errors: string[] = [];
    let message: string = "";
    
    message = "Status: " + error.status;
    message += " - Status Text: " + error.statusText;
    if (error instanceof HttpErrorResponse) {
      message += " - Exception Message: " + error.error.title;
    }
    errors.push(message); */
    
    /* console.error('An error occurred', errors);
    return throwError(() => errors); */
    console.error('An error occurred', error);
    return throwError(() => error);
  }
}
